// source: design/src/pages/EAMPage.tsx (export 2026-04-24)
/* eslint-disable max-len */
import SI from '../si/si_ja';

export default {
  // Reuse shared SI common copy to keep sub-pages aligned with SI root updates.
  common: SI.common,
  heroImage: 'si/images/hero-eam.jpg',
  heroTitle: '企業資産管理（EAM）',
  heroTagline: '資産のライフサイクル全体を管理し、資産価値を最大化',
  intro: [
    'EAM（Enterprise Asset Management）は、企業の物理資産のライフサイクル全体を管理する専用の情報システムであり、資産の購買、設置、運用、保守、廃棄の全工程をカバーします。',
    'ERPの資産管理モジュールと比較すると、EAMは資産の運用保守管理の深みに特化しており、予防保全、作業指示書管理、故障分析などの専門機能を提供し、製造、エネルギー、交通などの資産集約型産業の核心システムです。',
    '飛狼は企業のデジタル資産管理体制構築を支援し、インテリジェントな保守戦略により設備故障率を削減し、資産の使用寿命を延ばします。',
  ],
  modules: [
    {
      icon: 'si/si-icons/clipboard-list.svg',
      title: '資産台帳管理',
      desc: '資産の基本情報、技術仕様、位置状態、帰属関係などの核心データを含む、完全な資産電子ファイルを構築します。',
    },
    {
      icon: 'si/si-icons/shield-check.svg',
      title: '予防保全',
      desc: '時間または使用量に基づいて保守計画をトリガーし、自動的に保守タスクを生成し、計画外停止を30%〜50%削減します。',
    },
    {
      icon: 'si/si-icons/wrench.svg',
      title: '作業指示書管理',
      desc: '作業指示書の作成、配工、実行、検収からクローズまでの全工程のデジタル管理を実現し、モバイル端末での現場作業をサポートします。',
    },
    {
      icon: 'si/si-icons/package.svg',
      title: '部品・予備品管理',
      desc: '部品需要予測、安全在庫アラート、購買計画の自動生成を行い、部品コストと供給保障のバランスを取ります。',
    },
    {
      icon: 'si/si-icons/file-check.svg',
      title: 'コンプライアンスと監査',
      desc: 'ISO 55000などの資産管理基準を満たし、完全な監査追跡とコンプライアンスレポートを提供します。',
    },
    {
      icon: 'si/si-icons/smartphone.svg',
      title: 'モバイル点検巡回',
      desc: 'NFC/QRコードスキャンによる点検巡回をサポートし、オフラインでのデータ収集と異常のリアルタイム報告を行い、点検効率を40%以上向上させます。',
    },
    {
      icon: 'si/si-icons/search.svg',
      title: '故障分析',
      desc: 'RCA根本原因分析、故障モード統計、MTBF/MTTR指標の追跡により、保守戦略を継続的に最適化します。',
    },
    {
      icon: 'si/si-icons/bar-chart-3.svg',
      title: 'KPIとレポート',
      desc: '資産稼働率、保守コスト、作業指示書完了率などの重要指標の可視化ダッシュボードを提供します。',
    },
  ],
  scenarios: [
    {
      icon: 'si/si-icons/zap.svg',
      title: '電力・エネルギー',
      desc: '変電所・発電所設備の点検管理、変圧器、開閉器、送電線路のライフサイクル全体の保守を行い、電網の安全かつ安定した運行を保障します。',
    },
    {
      icon: 'si/si-icons/flask-conical.svg',
      title: '石油化学',
      desc: '配管、貯蔵タンク、反応釜などの核心設備の腐食監視と予防保全を行い、安全生産の要件を満たし、装置の計画外停止リスクを削減します。',
    },
    {
      icon: 'si/si-icons/train.svg',
      title: '鉄道・軌道交通',
      desc: '列車車両、軌道設備、信号システムの保守管理を行い、運営の安全性と定時性を保障し、設備の耐用年数を延ばします。',
    },
    {
      icon: 'si/si-icons/server.svg',
      title: 'データセンター',
      desc: 'サーバー、UPS、空調などのITインフラの資産管理と保守を行い、ビジネスの継続性を保障し、TCO総所有コストを最適化します。',
    },
  ],
  benefits: [
    {
      // source: design/src/pages/EAMPage.tsx (icon: TrendingDown, color: #3784E6, export 2026-04-24)
      icon: 'si/si-icons/trending-down-blue.svg',
      title: '保守コスト18%削減',
      desc: '予防保全により緊急修理を削減し、部品最適化により在庫コストを削減',
    },
    {
      // source: design/src/pages/EAMPage.tsx (icon: Clock, color: #3784E6, export 2026-04-24)
      icon: 'si/si-icons/clock-blue.svg',
      title: '計画外停止35%削減',
      desc: '予測性保全により潜在的な故障を早期発見し、生産の継続性を保障',
    },
    {
      // source: design/src/pages/EAMPage.tsx (icon: Gauge, color: #3784E6, export 2026-04-24)
      icon: 'si/si-icons/gauge-blue.svg',
      title: '資産使用寿命延長',
      desc: '科学的な保守戦略により設備寿命が平均15%〜20%延長',
    },
    {
      // source: design/src/pages/EAMPage.tsx (icon: Award, color: #3784E6, export 2026-04-24)
      icon: 'si/si-icons/award-blue.svg',
      title: 'コンプライアンス効率向上',
      desc: 'デジタル監査追跡により、コンプライアンスチェック時間が50%短縮',
    },
  ],
};
